<div class="checkin-container">
  <div class="checkin-card">
    <div class="checkin-header">
      <h1 class="store-name">{{storeName}}</h1>
      <div class="checkin-description">Check in with your phone number to join our reward program</div>
    </div>

    <!-- STEP 1: Phone Number Input -->
    @if (currentStep === 1) {
      <form [formGroup]="form" class="checkin-form">
        <div class="row">
          <div class="form-field">
            <div class="phone-number-section">
              <input
                class="large-input"
                type="text"
                [value]="form.controls['phoneNumber'].value | usPhoneNumber"
                readonly
                placeholder="Enter Phone Number"
              >
            </div>
          </div>
        </div>

        <ng-container *ngTemplateOutlet="numpad"></ng-container>

        @if(isAbleToSearch()) {
          <app-button
            [isLoading]="isSearching"
            (onClick)="searchCustomer()"
            size="large"
            class="continue-button"
          >
            Continue
          </app-button>
        }
      </form>
    }

    <!-- STEP 2: Customer Information -->
    @if (currentStep === 2) {
      <form [formGroup]="form" class="checkin-form">
        <div class="row">
          <div class="form-field">
            <label class="form-field-label">Phone Number</label>
            <div class="phone-number-section">
              <input
                class="large-input"
                type="text"
                [value]="form.controls['phoneNumber'].value | usPhoneNumber"
                readonly
                placeholder="Enter Phone Number"
              >
              <div class="edit-button" (click)="handleBackToPhoneInput()">
                <span class="material-symbols-outlined">
                  edit
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="form-field">
            <label class="form-field-label">First Name</label>
            <input
              class="large-input"
              type="text"
              formControlName="firstName"
              style="text-transform: capitalize;"
              placeholder="First Name"
            >
            <div
              [@inputErrorAnimation]="showErrorState('firstName')"
              class="form-field-error"
            >
              First name is required
            </div>
          </div>
        </div>

        <div class="row">
          <div class="form-field">
            <label class="form-field-label">Last Name</label>
            <input
              class="large-input"
              type="text"
              formControlName="lastName"
              style="text-transform: capitalize;"
              placeholder="Last Name"
            >
            <div
              [@inputErrorAnimation]="showErrorState('lastName')"
              class="form-field-error"
            >
              Last name is required
            </div>
          </div>
        </div>

        <div class="button-group">
          <app-button
            (onClick)="handleBackToPhoneInput()"
            size="large"
            [type]="'secondary'"
          >
            Cancel
          </app-button>

          <app-button
            [isLoading]="isCheckin"
            (onClick)="handleContinueToNotification()"
            [disabled]="!form.valid"
            size="large"
          >
            Check-in
          </app-button>
        </div>
      </form>
    }

    <!-- STEP 3: SMS Notification Preference -->
    @if (currentStep === 3) {
      <div class="notification-form">
        <div class="customer-info">
          <div class="info-row">
            <label class="form-field-label">Full Name</label>
            <div class="info-value">{{getFullName()}}</div>
          </div>

          <div class="info-row">
            <label class="form-field-label">Phone Number</label>
            <div class="info-value">{{form.controls['phoneNumber'].value | usPhoneNumber}}</div>
          </div>
        </div>

        <div class="notification-statement">
          <span class="material-symbols-outlined info-icon">info</span>
          <p>I understand that <strong>{{storeName}}</strong> will NOT share my information with third parties</p>
        </div>

        <div class="notification-options">
          <label class="notification-option" [class.checked]="smsPreference === 'all'">
            <input
              type="checkbox"
              [checked]="smsPreference === 'all'"
              (change)="selectSmsPreference('all')"
            >
            <div class="option-content">
              <span class="material-symbols-outlined check-icon">
                {{ smsPreference === 'all' ? 'check_box' : 'check_box_outline_blank' }}
              </span>
              <div class="option-text">
                <strong>I agree</strong> to receive all notifications via SMS, including e-receipts, future appointment confirmations, reminders, discounted offers, and promotions sent to my phone number.
              </div>
            </div>
          </label>

          <label class="notification-option" [class.checked]="smsPreference === 'none'">
            <input
              type="checkbox"
              [checked]="smsPreference === 'none'"
              (change)="selectSmsPreference('none')"
            >
            <div class="option-content">
              <span class="material-symbols-outlined check-icon">
                {{ smsPreference === 'none' ? 'check_box' : 'check_box_outline_blank' }}
              </span>
              <div class="option-text">
                <strong>I do not want</strong> to receive any future promotions or discounts.
              </div>
            </div>
          </label>
        </div>

        <app-button
          (onClick)="confirmCheckin()"
          [disabled]="!smsPreference"
          size="large"
          class="confirm-button"
        >
          Confirm
        </app-button>
      </div>
    }
  </div>
</div>

<ng-template #numpad>
  <div class="numpad">
    <div class="numpad-row">
      <div class="numpad-button" (click)="appendNumber('1')">1</div>
      <div class="numpad-button" (click)="appendNumber('2')">2</div>
      <div class="numpad-button" (click)="appendNumber('3')">3</div>
    </div>
    <div class="numpad-row">
      <div class="numpad-button" (click)="appendNumber('4')">4</div>
      <div class="numpad-button" (click)="appendNumber('5')">5</div>
      <div class="numpad-button" (click)="appendNumber('6')">6</div>
    </div>
    <div class="numpad-row">
      <div class="numpad-button" (click)="appendNumber('7')">7</div>
      <div class="numpad-button" (click)="appendNumber('8')">8</div>
      <div class="numpad-button" (click)="appendNumber('9')">9</div>
    </div>
    <div class="numpad-row">
      <div class="numpad-button" (click)="deleteNumber()">
        <span class="material-symbols-outlined">backspace</span>
      </div>
      <div class="numpad-button" (click)="appendNumber('0')">0</div>
      <div style="flex: 1"></div>
    </div>
  </div>
</ng-template>
